import { withMetadata } from '@pf/shared-utility';
import { UserFragment } from '@control-tower/platform-loads';
import { UserProfile } from '@pf/shared-common';

export interface IUserFragment {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
}

export function AsUserFragment(
    profile?: UserProfile | null
): IUserFragment | undefined {
    return profile
        ? {
              id: profile.userId,
              firstName: profile.firstName,
              lastName: profile.lastName,
              email: profile.email,
          }
        : undefined;
}

export const UserFragmentSymbol = 'UserFragment';

export function withUserFragmentMetadata() {
    withMetadata<UserFragment>(UserFragmentSymbol, {
        id: String,
        firstName: String,
        lastName: String,
        email: String,
    });
}
